import React, { useState } from "react";
import InvoicePreview from "./InvoicePreview";

const ActionMenu = ({ row }) => {
  const [open, setOpen] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  return (
    <>
      <div className="position-relative">
        <button className="btn btn-sm btn-light" onClick={() => setOpen(!open)}>
          ⋮
        </button>

        {open && (
          <div
            className="dropdown-menu show"
            style={{ right: 0, position: "absolute", zIndex: 999 }}
          >
            <button
              className="dropdown-item"
              onClick={() => {
                setShowInvoice(true);
                setInvoiceData(row.__raw);
                setOpen(false);
              }}
            >
              Invoice Preview
            </button>
          </div>
        )}

        {open && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 998,
            }}
            onClick={() => setOpen(false)}
          />
        )}
      </div>

      {/* INVOICE MODAL */}
      {showInvoice && (
        <InvoicePreview
          show={showInvoice}
          onHide={() => setShowInvoice(false)}
          data={invoiceData}
        />
      )}
    </>
  );
};

export default ActionMenu;
